/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Emailconfirmed1Inputs */

const en__field_emailconfirmed1 = /** @type {(inputs: _Field_Emailconfirmed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email confirmed`)
};

/**
* | output |
* | --- |
* | "Email confirmed" |
*
* @param {_Field_Emailconfirmed1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_emailconfirmed1 = /** @type {((inputs?: _Field_Emailconfirmed1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Emailconfirmed1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_emailconfirmed1(inputs)
});
export { _field_emailconfirmed1 as "_field_emailConfirmed" }